import StaticComponent from '@/components/StaticComponent/404'
import ProjectDetails from '@/components/DynamicComponents/Projects/Navigation/ProjectDetails'
import BuildingGeneral from '@/components/DynamicComponents/Templates/Navigations/BuildingGeneral'
import BuildingShell from '@/components/DynamicComponents/Templates/Navigations/BuildingShell'
import InteriorInfo from '@/components/DynamicComponents/Templates/Navigations/InteriorInfo'
import SpecialtyInfo from '@/components/DynamicComponents/Templates/Navigations/SpecialtyInfo'
import SiteTakeOffs from '@/components/DynamicComponents/Templates/Navigations/SiteTakeoff'
import ProjectAnalysisSheet from '@/components/DynamicComponents/Projects/Navigation/AnalysisSheet'
import TemplateAnalysisSheet from '@/components/DynamicComponents/Templates/Navigations/AnalysisSheet'
import Reports from '@/components/DynamicComponents/Projects/Reports'
import ProjectNavigation from '@/components/DynamicComponents/Projects/Navigation/Main'
import ProjectChart from '@/components/DynamicComponents/Projects/Chart'
import TemplateChart from '@/components/DynamicComponents/Templates/Chart'
import ProjectDrawer from '@/components/DynamicComponents/Projects/Drawer'
import ProjectNotes from '@/components/DynamicComponents/Projects/Notes'
import { Acquisition, NewConstructions, Project } from './data.json'
import { instance, errorService } from '@/services/api'
import {
  projectAPIs,
  dropdownAPIs,
  templateAPIs,
  masterAPIs,
} from '@/services/authConstantsV1'
import router from '@/router'
import _ from 'lodash'
import Vue from 'vue'
import {
  calculateGridHeight,
  showNotification,
  calculateBarHeight,
} from '@/services/calculate'
import { formatCurrency, checkNumberDigits } from '@/services/convert'
import { addAssets } from '@/services/chart'
import MasterComponent from '@/components/DynamicComponents/Admin/MasterData'
import axios from 'axios'
import {
  socketEvents,
  calculations,
  updateSideBarDetails,
  checkEvents,
  checkSidebarEvents,
  checkUrls,
} from '@/services/config'
import moment from 'moment-timezone'

export default {
  components: {
    StaticComponent,
    'template-building-general': BuildingGeneral,
    'template-building-shell': BuildingShell,
    'template-interior-info': InteriorInfo,
    'template-site-takeoff': SiteTakeOffs,
    'project-chart': ProjectChart,
    'project-drawer': ProjectDrawer,
    'master-component': MasterComponent,
    'project-analysis-sheet': ProjectAnalysisSheet,
    'template-analysis-sheet': TemplateAnalysisSheet,
    'template-chart': TemplateChart,
    'template-common-area': SpecialtyInfo,
    'project-details': ProjectDetails,
    reports: Reports,
    'project-navigation': ProjectNavigation,
    'project-notes': ProjectNotes,
  },
  data() {
    return {
      checkNumberDigits: checkNumberDigits,
      userDetails: [],
      lastChecked: 1,
      projectNumber: null,
      intervalIds: [],
      originalOpen: null,
      originalSend: null,
      originalFetch: null,
      userActive: false,
      projectData: [],
      projectSteps: JSON.stringify(Project),
      projectModule: false,
      visibleExtra: false,
      expanded: false,
      key: 1,
      headStyle: {
        'font-weight': 'bold',
        background: '#333333 !important',
        color: '#ffffff !important',
        padding: '0 10px',
      },
      childComponent: BuildingGeneral,
      current: 0,
      title: '',
      editable: false,
      loading: false,
      hover: false,
      lastUpdated: 0,
      screenName: 'Building General',
      Totalsteps: [],
      templateId: this.$route.params.id,
      templateName: '',
      analysisType: '',
      buildingUse: '',
      loader: true,
      screenIndentifier: null,
      screenData: null,
      child: new Vue(),
      componentKey: 0,
      templateData: null,
      stepStatus: null,
      previousScreen: null,
      previousTemplateName: null,
      acquisitionData: JSON.stringify(Acquisition),
      constructionsData: JSON.stringify(NewConstructions),
      screenList: [],
      popupUpdation: false,
      loaderTitle: '',
      dropdownData: [],
      isShow: false,
      enableDeleteClone: false,
      enableAPI: false,
      tempId: [],
      collapsed: false,
      height: '400px',
      sideBarTitle: null,
      list: { taxList: [], assetList: [] },
      formatCurrency: formatCurrency,
      activeKey: '1',
      screen: null,
      visible: false,
      emptyImage: process.env.BASE_URL + 'resources/images/empty.png',
      calculateBarHeight: calculateBarHeight,
      tabKey: 6,
      sideBarLoader: true,
      form: {
        id: undefined,
        templateName: undefined,
        analysisTypeId: [],
        analysisType: undefined,
        structureProfileId: undefined,
        structureProfile: undefined,
        buildingUseId: undefined,
        buildingUse: undefined,
        status: undefined,
        isActive: undefined,
        costBasis: undefined,
        columnsDetails: undefined,
      },
      viewOnly: false,
      stepList: [],
      showSidebar: true,
      columnSettings: [],
      notes: [],
      projectNote: undefined,
      loaderNote: false,
      projectAssets: [],
      secondsInMinutes: this.secondsInMinutes,
      isRunning: false,
      isPause: false,
      urls: checkUrls,
      syncTime: Number(process.env.VUE_APP_TIME_TO_SYNC),
      stopTime: Number(process.env.VUE_APP_TIME_TO_STOP),
      lastPatchRequestTime: Date.now(),
      patchRequested: true,
      time: 0,
      timeSpent: 0,
      timer: null,
    }
  },
  created() {
    this.getColumnSettings()
    this.Totalsteps = []
    if (this.$route.name === 'project') {
      this.getProjectSideBarDetails()
      this.setTimers()
      this.current = 0
      this.stepList = JSON.parse(this.projectSteps)
      this.checkStatus()
      this.screenName = this.stepList[0].name
      this.projectModule = true
      this.childComponent = 'project-details'
      this.screen = this.stepList[0].screen
      this.getProjectById()
      this.getProjectNotes()
      this.userDetails = JSON.parse(localStorage.getItem('userDetails'))
      this.interceptRequests()
    } else {
      this.getDropDownData()
      this.projectModule = false
      this.getTemplateById()
      this.getTemplateSideBarDetails()
    }
  },
  mounted() {
    this.$root.$off('popupUpdation')
    this.$root.$on('popupUpdation', this.showPopup)
    this.$root.$off('openSidebar')
    this.$root.$on('openSidebar', this.openSidebar)
    this.$root.$off('reloadBanks')
    this.$root.$on('reloadBanks', this.loadGroupingBanks)
    this.$root.$off('projectSideBarUpdated')
    this.$root.$on('projectSideBarUpdated', this.recievedMessage)
    this.$root.$off('templateSideBarUpdated')
    this.$root.$on('templateSideBarUpdated', this.recievedMessage)
    this.$socketHub.$off('message-received')
    this.$socketHub.$on('message-received', this.recievedMessage)
    this.$root.$off('updateProjectName')
    this.$root.$on('updateProjectName', this.updateProjectName)
    this.$root.$off('removeAsset')
    this.$root.$on('removeAsset', this.removeAsset)
    this.$root.$off('updateAssetNameSidebar')
    this.$root.$on('updateAssetNameSidebar', this.updateAssetNameSidebar)
    this.$root.$off('addContract')
    this.$root.$on('addContract', this.addContract)
    this.$root.$off('addCategoryCode')
    this.$root.$on('addCategoryCode', this.addCategoryCode)
    this.$root.$off('updateColumnDetails')
    this.$root.$on('updateColumnDetails', this.updateColumnDetails)
    this.$root.$off('updateNavigation')
    this.$root.$on('updateNavigation', this.updateNavigation)
    this.$root.$off('changeAssetClass')
    this.$root.$on('changeAssetClass', this.changeAssetClass)
    this.$root.$on('expanded', expanded => {
      if (expanded) {
        this.expanded = true
      } else {
        this.expanded = false
      }
    })
  },
  beforeDestroy() {
    // this.child.$off('addNewRecord')
    this.restoreOriginalMethods()
    window.document.removeEventListener(
      'visibilitychange',
      this.handleVisibilityChange,
    )
    window.removeEventListener('beforeunload', this.handleBeforeUnload)
    this.intervalIds.forEach(intervalId => clearInterval(intervalId))
    this.intervalIds = []
    clearInterval(this.timer)
    this.timer = null
  },
  methods: {
    interceptRequests() {
      // Intercept XMLHttpRequest
      const that = this
      this.originalOpen = XMLHttpRequest.prototype.open
      this.originalSend = XMLHttpRequest.prototype.send
      this.originalFetch = fetch

      XMLHttpRequest.prototype.open = function(method, url) {
        this._method = method
        this._url = url
        return that.originalOpen.apply(this, arguments)
      }

      XMLHttpRequest.prototype.send = function(body) {
        that.updateLastRequestTime(body, this._url, this._method)
        return that.originalSend.apply(this, arguments)
      }
    },

    restoreOriginalMethods() {
      // Restore original XMLHttpRequest methods
      if (this.originalOpen) {
        XMLHttpRequest.prototype.open = this.originalOpen
      }
      if (this.originalSend) {
        XMLHttpRequest.prototype.send = this.originalSend
      }
    },

    updateLastRequestTime(dataOfReq, url, method) {
      const data =
        dataOfReq && typeof dataOfReq === 'string'
          ? JSON.parse(dataOfReq)
          : undefined
      const urlSync = url.includes('sync')
      const socketUrl = url.includes('sockjs-node')
      const isValidUrl = this.checkValidUrl(url)

      if (
        data &&
        typeof data === 'object' &&
        !Array.isArray(data) &&
        Object.prototype.hasOwnProperty.call(data, 'projectNumber') &&
        !urlSync
      ) {
        if (data.projectNumber && this.projectData.projectNumber !== data.projectNumber) {
          this.projectData.projectNumber = data.projectNumber
          this.projectNumber = data.projectNumber
          this.startTimer()
        } else {
          this.projectData.projectNumber = data.projectNumber
          this.projectNumber = data.projectNumber
          this.stopTimer()
        }
      } else if (method !== 'GET' && isValidUrl && !socketUrl) {
        this.lastPatchRequestTime = Date.now()
        this.patchRequested = true

        if (!this.isRunning) {
          this.startTimer()
        }
      }
    },

    handleBeforeUnload() {
      this.updateProjectTimer()
    },

    handleVisibilityChange(event) {
      if (event.srcElement.visibilityState === 'hidden') {
        this.stopTimer()
      } else if (this.patchRequested && !this.isRunning) {
        this.startTimer()
      }
    },

    checkValidUrl(url) {
      let valid = true
      this.urls.forEach(element => {
        if (url.includes(element)) {
          valid = false
        }
      })
      return valid
    },

    addNew() {
      this.child.$emit('addNewRecord')
    },

    cloneTakeOff() {
      this.child.$emit('cloneTakeOff')
    },

    deleteTakeOff() {
      this.child.$emit('deleteTakeOff')
    },

    onChange(current) {
      if (this.templateData && this.templateData.status !== 'Live') {
        this.viewOnly = false
      }
      this.previousScreen = this.current
      this.checkStatus()
      this.current = current
      this.screenName = this.Totalsteps[this.current].name
      this.screen = this.Totalsteps[this.current].screen
      this.screenData = this.screenList.find(
        i => i.screen_Name === this.Totalsteps[this.current].name,
      )
      if (this.projectModule) {
        switch (this.screenName) {
          case 'Reports':
            this.collapsed = false
            break
          case 'Analysis Sheet':
            this.form.analysisTypeId = []
            this.tempId = this.form.analysisTypeId
            break
          case 'New Construction - Actual Cost':
          case 'New Construction - Estimates':
          case 'New Construction - Indirect Cost':
            this.form.analysisTypeId = [2]
            this.enableAPI = !_.isEqual(this.form.analysisTypeId, this.tempId)
            this.tempId = this.form.analysisTypeId
            break
          case 'Building General':
            this.form.analysisTypeId = [1, 2]
            this.enableAPI = !_.isEqual(this.form.analysisTypeId, this.tempId)
            this.tempId = this.form.analysisTypeId
            break
          default:
            this.form.analysisTypeId = [1]
            this.enableAPI = !_.isEqual(this.form.analysisTypeId, this.tempId)
            this.tempId = this.form.analysisTypeId
            break
        }
      } else {
        if (this.screenName === 'Analysis Sheet') {
          this.viewOnly = true
        }
      }
      switch (this.current) {
        case 0:
          if (!this.projectModule) {
            this.childComponent = this.screen
            this.visibleExtra = this.Totalsteps[this.current].visibleExtra
            this.showSidebar = this.Totalsteps[this.current].showSidebar
            this.screenIndentifier = this.Totalsteps[
              this.current
            ].screenIndentifier
          } else {
            this.form.analysisTypeId = []
            this.enableAPI = true
            this.tempId = []
            this.childComponent = this.screen
            this.visibleExtra = this.Totalsteps[this.current].visibleExtra
            this.showSidebar = this.Totalsteps[this.current].showSidebar
          }
          this.componentKey++
          break
        case 1:
          if (!this.projectModule) {
            this.childComponent = this.screen
            this.visibleExtra = this.Totalsteps[this.current].visibleExtra
            this.showSidebar = this.Totalsteps[this.current].showSidebar
            this.screenIndentifier = this.Totalsteps[
              this.current
            ].screenIndentifier
          } else {
            this.childComponent = this.screen
            this.screenIndentifier = this.Totalsteps[
              this.current
            ].screenIndentifier
            this.visibleExtra = this.Totalsteps[this.current].visibleExtra
            this.showSidebar = this.Totalsteps[this.current].showSidebar
          }
          this.componentKey++
          break
        case 2:
          if (!this.projectModule) {
            this.childComponent = this.screen
            this.visibleExtra = this.Totalsteps[this.current].visibleExtra
            this.showSidebar = this.Totalsteps[this.current].showSidebar
            this.screenIndentifier = this.Totalsteps[
              this.current
            ].screenIndentifier
          } else {
            this.childComponent = this.screen
            this.screenIndentifier = this.Totalsteps[
              this.current
            ].screenIndentifier
            this.visibleExtra = this.Totalsteps[this.current].visibleExtra
            this.showSidebar = this.Totalsteps[this.current].showSidebar
          }
          this.componentKey++
          break
        case 3:
          if (!this.projectModule) {
            this.childComponent = this.screen
            this.visibleExtra = this.Totalsteps[this.current].visibleExtra
            this.showSidebar = this.Totalsteps[this.current].showSidebar
            this.screenIndentifier = this.Totalsteps[
              this.current
            ].screenIndentifier
          } else {
            this.childComponent = this.screen
            this.screenIndentifier = this.Totalsteps[
              this.current
            ].screenIndentifier
            this.visibleExtra = this.Totalsteps[this.current].visibleExtra
            this.showSidebar = this.Totalsteps[this.current].showSidebar
          }
          this.componentKey++
          break
        case 4:
          if (!this.projectModule) {
            this.childComponent = this.screen
            this.visibleExtra = this.Totalsteps[this.current].visibleExtra
            this.showSidebar = this.Totalsteps[this.current].showSidebar
            this.screenIndentifier = this.Totalsteps[
              this.current
            ].screenIndentifier
          } else {
            this.childComponent = this.screen
            this.screenIndentifier = this.Totalsteps[
              this.current
            ].screenIndentifier
            this.visibleExtra = this.Totalsteps[this.current].visibleExtra
            this.showSidebar = this.Totalsteps[this.current].showSidebar
          }
          this.componentKey++
          break
        case 5:
          if (!this.projectModule) {
            this.childComponent = this.screen
            this.visibleExtra = this.Totalsteps[this.current].visibleExtra
            this.showSidebar = this.Totalsteps[this.current].showSidebar
            this.screenIndentifier = this.Totalsteps[
              this.current
            ].screenIndentifier
          } else {
            this.childComponent = this.screen
            this.screenIndentifier = this.Totalsteps[
              this.current
            ].screenIndentifier
            this.visibleExtra = this.Totalsteps[this.current].visibleExtra
            this.showSidebar = this.Totalsteps[this.current].showSidebar
          }
          this.componentKey++
          break
        case 6:
          if (this.projectModule) {
            this.childComponent = this.screen
            this.screenIndentifier = this.Totalsteps[
              this.current
            ].screenIndentifier
            this.componentKey++
            this.visibleExtra = this.Totalsteps[this.current].visibleExtra
            this.showSidebar = this.Totalsteps[this.current].showSidebar
          }
          break
        case 7:
          if (this.projectModule) {
            this.childComponent = this.screen
            this.screenIndentifier = this.Totalsteps[
              this.current
            ].screenIndentifier
            this.componentKey++
            this.visibleExtra = this.Totalsteps[this.current].visibleExtra
            this.showSidebar = this.Totalsteps[this.current].showSidebar
          }
          break
        case 8:
          if (this.projectModule) {
            this.childComponent = this.screen
            this.screenIndentifier = this.Totalsteps[
              this.current
            ].screenIndentifier
            this.componentKey++
            this.visibleExtra = this.Totalsteps[this.current].visibleExtra
            this.showSidebar = this.Totalsteps[this.current].showSidebar
          }
          break
        case 9:
          if (this.projectModule) {
            this.childComponent = this.screen
            this.screenIndentifier = this.Totalsteps[
              this.current
            ].screenIndentifier
            this.componentKey++
            this.visibleExtra = this.Totalsteps[this.current].visibleExtra
            this.showSidebar = this.Totalsteps[this.current].showSidebar
          }
          break
        case 10:
          if (this.projectModule) {
            this.childComponent = this.screen
            this.screenIndentifier = this.Totalsteps[
              this.current
            ].screenIndentifier
            this.componentKey++
            this.visibleExtra = this.Totalsteps[this.current].visibleExtra
            this.showSidebar = this.Totalsteps[this.current].showSidebar
          }
          break
      }
      this.changeCurrentStatus()
    },

    getTemplateById() {
      this.loader = true
      instance
        .get(templateAPIs.template.getTemplateDetails(this.$route.params.id))
        .then(response => {
          const result = _.get(response.data, 'result', null)
          this.loader = false
          this.templateData = result
          this.form = result
          this.screenList = _.get(result, 'screen_Details', [])
          if (result.analysisTypeId === 1) {
            this.Totalsteps = JSON.parse(this.acquisitionData)
          } else {
            this.Totalsteps = JSON.parse(this.constructionsData)
          }
          this.Totalsteps.forEach(element => {
            const screen = this.screenList.find(
              i => i.screen_Name === element.name,
            )
            if (screen) {
              element.id = screen.id
              if (this.screenName !== element.name) {
                if (screen.status === 1) {
                  element.status = 'finish'
                } else {
                  element.status = null
                }
              }
              return element
            }
          })
          if (result && result.status === 'Live') {
            this.viewOnly = true
          }
        })
        .catch(error => {
          this.loader = false
          errorService(error)
        })
    },

    setTimers() {
      // -------------------------------------------------------------------//

      // Set timer to update project time log every 5 minutes
      const updateProjectInterval = setInterval(
        function() {
          if (this.isRunning) {
            this.updateProjectTimer()
          }
        }.bind(this),
        this.syncTime,
      )

      this.intervalIds.push(updateProjectInterval)
      // -------------------------------------------------------------------//

      // Set timer to stop clock if user is inactive for more than 5 miutes
      const userActiveInterval = setInterval(
        function() {
          this.checkProjectIsActive()
        }.bind(this),
        300000,
      )
      this.intervalIds.push(userActiveInterval)

      // -------------------------------------------------------------------//
    },

    checkProjectIsActive() {
      // Stop timer if project is not active for 5 minutes
      if (this.projectData && !this.projectData.isArchive && this.isRunning) {
        if (Date.now() - this.lastPatchRequestTime >= this.stopTime) {
          this.stopTimer() // Stop the timer
          this.patchRequested = false
        }
      }
    },

    startTimer() {
      this.isRunning = true
      this.isPause = false

      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }

      this.getProjectTimer()

      this.timer = setInterval(() => {
        this.timeSpent++
        this.time++

        const obj = {
          projectNumber: this.projectData && this.projectData.projectNumber ? this.projectData.projectNumber.toString() : '',
          timeSpent: this.timeSpent,
        }

        this.updateLocalStorage(obj)
      }, 1000)

      // Call API to get time log
      this.getProjectTimeLog()
    },

    stopTimer() {
      this.isRunning = false
      this.isPause = true
      clearInterval(this.timer)
      this.timer = null

      this.updateProjectTimer() // Update the time logs in the database
    },

    setTimeInLocalStorage() {
      // Get logs data from api response
      const logs = this.projectData.projectTimeLogs.find(
        user => user.userId === this.userDetails.id,
      )

      if (logs) {
      // create object to store data in local storage
        const obj = {
          userId: logs.userId,
          projectNumber: logs.projectNumber,
          totalTimeSpent: logs.timeSpent,
        }

        this.updateLocalStorage(obj)
      }

      // // Get local storage values
      // const timers = JSON.parse(localStorage.getItem('userSpendTime')) || []

      // if (timers.length > 0) {
      //   const index = timers.findIndex(
      //     i => i.projectNumber === logs.projectNumber,
      //   )

      //   if (index > -1 && timers[index].totalTimeSpent < logs.timeSpent) {
      //     this.updateLocalStorage(obj)
      //   }
      // } else {
      //   this.updateLocalStorage(obj)
      // }
    },

    updateLocalStorage(obj) {
      // Get local storage values
      const timers = JSON.parse(localStorage.getItem('userSpendTime')) || []

      if (timers.length > 0) {
        const index = timers.findIndex(
          i => i.projectNumber === obj.projectNumber.toString(),
        )

        if (index > -1) {
          if (obj.timeSpent || obj.timeSpent === 0) {
            timers[index].timeSpent = obj.timeSpent
          }

          if (obj.totalTimeSpent && obj.totalTimeSpent > timers[index].totalTimeSpent) {
            timers[index].totalTimeSpent = obj.totalTimeSpent
          } else if (!timers[index].totalTimeSpent) {
            timers[index].totalTimeSpent = 0
          }
        } else {
          timers.push(obj)
        }
      } else {
        timers.push(obj)
      }

      localStorage.setItem('userSpendTime', JSON.stringify(timers))
    },

    getProjectTimer() {
      const data = JSON.parse(localStorage.getItem('userSpendTime'))
      if (data) {
        const project = data.find(
          i => i.projectNumber === this.projectData.projectNumber,
        )
        if (project) {
          const projectTimeSpent = Number(project.timeSpent) || 0
          this.timeSpent = projectTimeSpent > (this.syncTime / 1000) ? 0 : projectTimeSpent
          this.time = (Number(project.totalTimeSpent) || 0) + this.timeSpent
        } else {
          this.timeSpent = 0
          this.time = 0
        }
      } else {
        this.timeSpent = 0
        this.time = 0
      }
    },

    updateProjectTimer() {
      const userTimeLogs =
        JSON.parse(localStorage.getItem('userSpendTime')) || []

      if (
        this.projectData &&
        this.projectData.projectNumber &&
        !this.projectData.isArchive &&
        this.patchRequested
      ) {
        const request = []
        if (userTimeLogs.length > 0) {
          userTimeLogs.forEach(timeLog => {
            if (timeLog.timeSpent > 0) {
              request.push({
                userId: this.userDetails.id,
                projectNumber: timeLog.projectNumber,
                timeSpent: timeLog.timeSpent || 0,
                name: this.userDetails.name,
              })

              if (timeLog.projectNumber === this.projectData.projectNumber.toString()) {
                this.timeSpent = 0
              }

              const obj = {
                projectNumber: timeLog.projectNumber,
                timeSpent: 0,
                totalTimeSpent: timeLog.totalTimeSpent + timeLog.timeSpent,
              }

              this.updateLocalStorage(obj)
            }
          })

          if (request.length > 0) {
            Vue.prototype.sendSocket('UserTimeLog', request)
          }
        }
      }
    },

    getProjectTimeLog() {
      instance
        .get(projectAPIs.project.timeLogs(this.projectData.projectNumber))
        .then(response => {
          const result = _.get(response.data, 'result', null)

          if (result) {
            // create object to store data in local storage
            const obj = {
              projectNumber: result.projectNumber.toString(),
              totalTimeSpent: result.timeSpent,
            }

            this.updateLocalStorage(obj)
            this.getProjectTimer()
          }
        })
        .catch(err => {
          errorService(err)
        })
    },

    getProjectById() {
      this.loader = true
      instance
        .get(projectAPIs.project.delete(this.$route.params.id))
        .then(response => {
          const result = _.get(response.data, 'result', [])
          this.loader = false
          this.projectData = result
          if (this.projectData && !this.projectData.isArchive) {
            window.document.addEventListener(
              'visibilitychange',
              this.handleVisibilityChange,
            )
            window.addEventListener('beforeunload', this.handleBeforeUnload)
            this.projectData.projectTimeLogs = result.projectTimeLogs || []
            if (this.projectData.projectNumber) {
              this.setTimeInLocalStorage()
              this.startTimer()
            }
          } else {
            this.stopTimer()
          }
          sessionStorage.setItem('Is-Archive', this.projectData.isArchive)
          this.screenList = _.get(result, 'screen_Details', [])
          this.screenData = this.screenList.find(
            i => i.screen_Name === this.Totalsteps[0].name,
          )
          this.stepList.forEach(element => {
            const screen = this.screenList.find(
              i => i.screen_Name === element.name,
            )
            if (screen) {
              element.id = screen.id
              if (this.screenName !== element.name) {
                if (screen.status === 1) {
                  element.status = 'finish'
                } else {
                  element.status = null
                }
              }
              return element
            }
          })
          if (
            !JSON.parse(sessionStorage.getItem('Is-Archive')) &&
            this.projectData.archiveStatus !== 'QUEUED'
          ) {
            this.getDropDownData()
          } else {
            if (this.tabKey === '1') {
              this.onChange(0)
            }
            this.loader = false
            this.isShow = true
            this.popupUpdation = false
            this.loaderTitle = ''
            Object.assign(this.dropdownData, { calculation: calculations })
            this.getCostTypes()
          }
        })
        .catch(err => {
          this.loader = false
          errorService(err)
        })
    },

    getProjectNotes() {
      instance
        .get(projectAPIs.project.notes.list(this.$route.params.id))
        .then(response => {
          this.notes = _.get(response.data, 'result', [])
        })
        .catch(err => {
          errorService(err)
        })
    },

    addProjectNotes() {
      this.loaderNote = true
      instance
        .post(projectAPIs.project.notes.add(this.$route.params.id), {
          note: this.projectNote,
        })
        .then(response => {
          const newData = [...this.notes]
          newData.push(_.get(response.data, 'result', null))
          this.notes = [...newData]
          this.projectNote = undefined
          this.loaderNote = false
        })
        .catch(err => {
          this.loaderNote = false
          errorService(err)
        })
    },

    getColumnSettings() {
      let url = templateAPIs.template.columns.list(this.$route.params.id)
      if (this.$route.name === 'project') {
        url = projectAPIs.project.asset.columns.list(this.$route.params.id)
      }
      instance
        .get(url)
        .then(response => {
          this.columnSettings = _.get(response.data, 'result', [])
        })
        .catch(error => {
          this.loader = false
          errorService(error)
        })
    },

    updateColumnSettings(request) {
      let url = templateAPIs.template.columns.update(this.$route.params.id)
      if (this.$route.name === 'project') {
        url = projectAPIs.project.asset.columns.update(this.$route.params.id)
      }
      instance
        .put(url, request)
        .then(response => {
          const columnSettings = [...this.columnSettings]
          const index = columnSettings.findIndex(
            i =>
              i.screenId === request.screenId &&
              i.tableName === request.tableName,
          )
          if (index > -1) {
            columnSettings[index].columnDetails = request.columnDetails
          } else {
            columnSettings.push(_.get(response.data, 'result', null))
          }
          this.columnSettings = [...columnSettings]
        })
        .catch(error => {
          errorService(error)
        })
    },

    updateProjectName(value) {
      this.projectData.projectName = value
    },

    exit() {
      if (!this.projectModule) {
        router.push({ path: '/templates' })
      } else {
        window.document.removeEventListener(
          'visibilitychange',
          this.handleVisibilityChange,
        )
        window.removeEventListener('beforeunload', this.handleBeforeUnload)
        sessionStorage.removeItem('Is-Archive')
        router.push({ path: '/dashboard' })
        clearInterval(this.timer)
        this.timer = null
        if (!this.projectData.isArchive) {
          this.updateProjectTimer()
        }
      }
    },

    proceed() {
      this.onChange(this.current + 1)
    },

    editTemplateName() {
      this.editable = true
      this.previousTemplateName = this.form.templateName
    },

    cancelEdit() {
      this.editable = false
      this.form.templateName = this.previousTemplateName
    },

    saveTemplateName() {
      this.loading = true
      instance
        .patch(templateAPIs.template.updateTemplate(this.$route.params.id), {
          templateName: this.form.templateName,
        })
        .then(response => {
          this.loading = false
          showNotification(
            'success',
            'Template',
            _.get(response.data, 'message', undefined),
          )
          this.editable = false
        })
        .catch(err => {
          this.loading = false
          this.editable = false
          errorService(err)
        })
    },

    checkStatus() {
      const data = [...this.stepList]
      const screen = this.screenList.find(
        i => i.screen_Name === this.screenName,
      )
      if (screen) {
        if (screen.status === 1) {
          data[this.previousScreen]['status'] = 'finish'
        } else {
          data[this.previousScreen]['status'] = null
        }
      }
      if (this.Totalsteps.length > 0) {
        const totalSteps = [...this.Totalsteps]
        if (screen) {
          if (screen.status === 1) {
            totalSteps[this.previousScreen]['status'] = 'finish'
          } else {
            totalSteps[this.previousScreen]['status'] = null
          }
        }
        this.Totalsteps = totalSteps
      }
      this.stepList = data
      this.stepStatus = null
    },

    changeCurrentStatus() {
      this.Totalsteps = this.Totalsteps.map((steps, index) => {
        if (index !== this.current) {
          if (steps.status === 'process') {
            steps['status'] = null
          }
        } else {
          steps['status'] = 'process'
        }
        return steps
      })
    },

    showPopup(show, flag, title) {
      if (flag) {
        this.popupUpdation = show
        this.loaderTitle = title
      }
    },

    async getDropDownData() {
      this.dropdownData = []
      this.loader = true
      this.popupUpdation = true
      this.loaderTitle = 'Loading...'
      Promise.all([
        this.loadDropdowns(),
        this.loadCategoryCodes(),
        this.loadContracts(),
        this.loadUnits(),
        this.loadTemplates(),
        this.loadTenantTypes(),
        this.loadTenantBank(),
        this.loadCostTypes(),
      ])
        .then(
          axios.spread((...responses) => {
            const result = JSON.stringify(
              _.get(responses[0].data, 'result', []),
            )
            this.dropdownData = JSON.parse(result)
            Object.assign(this.dropdownData, { calculation: calculations })
            if (this.$route.name === 'project') {
              this.categoryCodeList = _.get(responses[1].data, 'result', [])
              Object.assign(this.dropdownData, {
                category: this.categoryCodeList,
              })
              this.contractList = _.get(responses[2].data, 'result', [])
              Object.assign(this.dropdownData, { contract: this.contractList })
              const unitList = _.get(responses[3].data, 'result', [])
              Object.assign(this.dropdownData, { unit: unitList })
              Object.assign(this.dropdownData, {
                template: _.get(responses[4].data, 'result', []),
              })
              Object.assign(this.dropdownData, {
                analysisType: this.dropdownData.analysis_type,
              })
              Object.assign(this.dropdownData, {
                structureProfile: this.dropdownData.structure_profile,
              })
              const costType = _.get(responses[7].data, 'result', [])
              Object.assign(this.dropdownData, { costType: costType })
            }
            Object.assign(this.dropdownData, {
              tenantType: _.get(responses[5].data, 'result', []),
            })
            Object.assign(this.dropdownData, {
              tenantBank: _.get(responses[6].data, 'result', []).filter(
                i => i.isActive,
              ),
            })
            if (this.tabKey === '1') {
              this.onChange(0)
            }
            this.loader = false
            this.isShow = true
            this.popupUpdation = false
            this.loaderTitle = ''
          }),
        )
        .catch(error => {
          this.loader = false
          this.popupUpdation = false
          this.dropdownData = []
          this.loaderTitle = ''
          errorService(error)
        })
    },

    // select changes in child for delete and clone
    enableExtraButtons(value) {
      this.enableDeleteClone = value
    },

    openSidebar(flag, title, key) {
      this.collapsed = flag
      this.sideBarTitle = title
      this.activeKey = key
      this.height = calculateGridHeight('projectSideBarContainer', false, true)
      if (flag && this.projectModule) {
        this.$root.$emit('gridSizeChange', true)
      }
    },

    tabClick(key) {
      this.activeKey = key
    },

    onTabeChange(key) {
      this.tabKey = key
      if (key === '1') {
        this.loader = true
        this.getDropDownData()
      }
    },

    closeSidebar() {
      this.collapsed = false
      if (this.projectModule) {
        this.$root.$emit('gridSizeChange', false)
      }
    },

    hideSideBar(flag) {
      this.collapsed = !flag
    },

    showDrawer() {
      this.visible = !this.visible
      this.$root.$emit('showDrawer', this.visible)
    },

    removeAsset(id) {
      if (
        this.list['taxList'].length > 0 &&
        this.list['assetList'].length > 0
      ) {
        const taxindex = this.list['taxList'].findIndex(i => i.assetId === id)
        const assetindex = this.list['assetList'].findIndex(
          i => i.assetId === id,
        )
        this.list['taxList'].splice(taxindex, 1)
        this.list['assetList'].splice(assetindex, 1)
        const taxIndex = this.list['taxList'].findIndex(
          i => i.name === 'Total Project',
        )
        const taxData = this.list['taxList'].filter(
          i => i.name !== 'Total Project',
        )
        if (taxIndex > -1) {
          this.list['taxList'][taxIndex]['cost_Basis'] = taxData.reduce(
            (total, item) => {
              return (
                total + Number(isNaN(item.cost_Basis) ? 0 : item.cost_Basis)
              )
            },
            0,
          )
          this.list['taxList'][taxIndex]['asset_Details'] = []
          this.list['taxList'][taxIndex]['asset_Details'] = addAssets(taxData)
        }
        const assetIndex = this.list['assetList'].findIndex(
          i => i.asset_Name === 'Total Project',
        )
        const assetData = this.list['assetList'].filter(
          i => i.asset_Name !== 'Total Project',
        )
        if (assetIndex > -1) {
          this.list['assetList'][assetIndex]['cost_Basis'] = assetData.reduce(
            (total, item) => {
              return (
                total + Number(isNaN(item.cost_Basis) ? 0 : item.cost_Basis)
              )
            },
            0,
          )
          this.list['assetList'][assetIndex]['asset_Details'] = []
          this.list['assetList'][assetIndex]['asset_Details'] = addAssets(
            assetData,
          )
        }
      }
    },

    updateAssetNameSidebar(key, value, record) {
      if (
        this.list['taxList'].length > 0 &&
        this.list['assetList'].length > 0
      ) {
        const taxIndex = this.list['taxList'].findIndex(
          i => i.assetId === record.id,
        )
        const assetIndex = this.list['assetList'].findIndex(
          i => i.assetId === record.id,
        )
        if (key === 'description' && taxIndex > -1 && assetIndex > -1) {
          this.list['taxList'][taxIndex].name = !value
            ? 'Asset - ' + record.assetNumber
            : value
          this.list['assetList'][assetIndex].name = !value
            ? 'Asset - ' + record.assetNumber
            : value
        }
      }
    },

    loadDropdowns() {
      this.dropdownData = []
      this.loader = true
      this.popupUpdation = true
      this.loaderTitle = 'Loading...'
      const req = {
        analysis_type: 0,
        structure_Profile: 0,
        construction_quality_factor: 0,
        condition_factor: 0,
        role: 0,
        tenant_approach: 0,
        bank_interior_grouping: 0,
        building_Use: 0,
      }
      return instance.post(dropdownAPIs.dropdown, req)
    },

    loadCategoryCodes() {
      if (this.$route.name === 'project') {
        return instance.get(
          projectAPIs.dropdown.list(this.$route.params.id, 'category-code'),
        )
      }
    },

    loadContracts() {
      if (this.$route.name === 'project') {
        return instance.get(
          projectAPIs.dropdown.list(this.$route.params.id, 'contract'),
        )
      }
    },

    loadUnits() {
      if (this.$route.name === 'project') {
        return instance.get(
          projectAPIs.dropdown.list(this.$route.params.id, 'unit'),
        )
      }
    },

    loadTemplates() {
      if (this.$route.name === 'project') {
        return instance.get(dropdownAPIs.templates)
      }
    },

    loadTenantTypes() {
      return instance.post(masterAPIs.tenantType.list, {
        pageSize: 10000,
        currentPage: 0,
        sortColumn: 'tenantType',
        isAscending: true,
      })
    },

    loadTenantBank() {
      return instance.post(masterAPIs.tenantBank.list, {
        pageSize: 10000,
        currentPage: 0,
        sortColumn: 'tenantName',
        isAscending: true,
      })
    },

    loadCostTypes() {
      if (this.$route.name === 'project') {
        return instance.get(projectAPIs.dropdown.costType)
      }
    },

    getCostTypes() {
      instance.get(projectAPIs.dropdown.costType).then(response => {
        Object.assign(this.dropdownData, {
          costType: _.get(response.data, 'result', []),
        })
      })
    },

    getProjectSideBarDetails() {
      instance
        .get(projectAPIs.project.sidebar(this.$route.params.id))
        .then(response => {
          this.list.taxList = _.get(response.data, 'result.taxLifeMode', [])
          this.list.assetList = _.get(
            response.data,
            'result.assetClassMode',
            [],
          )
          this.sideBarLoader = false
        })
        .catch(error => {
          errorService(error)
          this.sideBarLoader = false
        })
    },

    getTemplateSideBarDetails() {
      instance
        .get(templateAPIs.template.getSidebarDetails(this.$route.params.id))
        .then(response => {
          this.list['taxList'] = []
          this.list['assetList'] = []

          _.get(response.data.result, 'taxLifeMode', []).forEach(element => {
            element.costBasis = Number(
              isNaN(element.costBasis) ? 0 : element.costBasis,
            )
            this.list['taxList'].push(element)
          })

          _.get(response.data.result, 'assetClassMode', []).forEach(element => {
            element.costBasis = Number(
              isNaN(element.costBasis) ? 0 : element.costBasis,
            )
            this.list['assetList'].push(element)
          })

          this.sideBarLoader = false
        })
        .catch(error => {
          errorService(error)
          this.sideBarLoader = false
        })
    },

    loadSideBarDetails() {
      this.sideBarLoader = true
      if (this.projectModule) {
        this.getProjectSideBarDetails()
      } else {
        this.getTemplateSideBarDetails()
      }
    },

    loadGroupingBanks() {
      instance
        .post(dropdownAPIs.dropdown, {
          bank_interior_grouping: 0,
          tenant_bank: 0,
        })
        .then(response => {
          this.dropdownData.bank_interior_grouping = _.get(
            response.data,
            'result.bank_interior_grouping',
            [],
          )
          this.dropdownData.tenant_bank = _.get(
            response.data,
            'result.tenant_bank',
            [],
          )
        })
    },

    addContract(data) {
      this.dropdownData.contract.push({
        id: data.id,
        masterId: data.masterId,
        option: `${data.contract} - ${data.contractName}`,
        value: `${data.contract} - ${data.contractName}`,
        description: data.contractName,
      })
      this.dropdownData.contract = _.orderBy(
        this.dropdownData.contract,
        ['contract'],
        ['asc'],
      )
    },

    addCategoryCode(data, contracts) {
      this.dropdownData.category.push(data)
      this.dropdownData.category = _.orderBy(
        this.dropdownData.category,
        ['id'],
        ['asc'],
      )
      if (contracts && contracts.length > 0) {
        contracts.forEach(element => {
          this.dropdownData.contract.push({
            id: element.id,
            masterId: element.masterId,
            option: `${element.contract} - ${element.contractName}`,
            value: `${element.contract} - ${element.contractName}`,
            description: element.contractName,
          })
          this.dropdownData.contract = _.orderBy(
            this.dropdownData.contract,
            ['contract'],
            ['asc'],
          )
        })
      }
    },

    updateColumnDetails(columns) {
      this.projectData.columnsDetails = columns
    },

    changeAssetClass(flag) {
      this.projectData.isAssetClassChanged = flag
    },

    updateNavigation(assets) {
      if (this.projectModule && assets && assets.length > 0) {
        this.projectAssets = [...assets]
        const steps = this.stepList
        const acquisition = assets.some(i => i.analysisTypeId === 1)
        const newConstruction = assets.some(i => i.analysisTypeId === 2)
        let key = 0
        if (acquisition && newConstruction) {
          steps.map((i, index) => {
            i.show = true
            i.key = index + 1
            return i
          })
          this.Totalsteps = steps
        } else if (acquisition) {
          steps.map(i => {
            if (i.analysisTypeId.includes(1) || i.analysisTypeId === 'all') {
              i.show = true
              i.key = key + 1
              key++
            } else {
              i.show = false
            }
            return i
          })
          this.Totalsteps = steps.filter(
            i => i.analysisTypeId.includes(1) || i.analysisTypeId === 'all',
          )
        } else if (newConstruction) {
          steps.map(i => {
            if (i.analysisTypeId.includes(2) || i.analysisTypeId === 'all') {
              i.show = true
              i.key = key + 1
              key++
            } else {
              i.show = false
            }
            return i
          })
          this.Totalsteps = steps.filter(
            i => i.analysisTypeId.includes(2) || i.analysisTypeId === 'all',
          )
        }
      } else if (this.projectModule && assets && assets.length === 0) {
        this.projectAssets = [...assets]
        this.Totalsteps = []
      }
    },

    recievedMessage(message, flag) {
      const data = JSON.parse(message.message)
      if (checkSidebarEvents(data.EventType)) {
        this.sideBarLoader = true
        this.list.taxList = []
        this.list.assetList = []
        if (!flag) {
          this.$root.$emit('popupUpdation', false, true, null)
        }
        const taxLife = _.get(data.Result, 'TaxLifeMode', [])
        const assetClass = _.get(data.Result, 'AssetClassMode', [])
        const sidebarDetails = updateSideBarDetails(
          taxLife,
          assetClass,
          this.list.taxList,
          this.list.assetList,
        )
        this.list.taxList = [...sidebarDetails.taxLifeList]
        this.list.assetList = [...sidebarDetails.assetClassList]
        this.sideBarLoader = false
      } else if (checkEvents(data.EventType)) {
        this.$root.$emit('popupUpdation', false, true, null)
      } else if (data.EventType === socketEvents.error) {
        showNotification(
          'error',
          'Socket',
          _.get(data, 'Result.Message', null),
        )
        this.$root.$emit('popupUpdation', false, true, null)
      }
    },
  },
  filters: {
    secondsInMinutes: function(time) {
      const duration = moment.duration(time, 'seconds')
      const hours = Math.floor(duration.asHours())
      const minutes = duration.minutes()
      const seconds = duration.seconds()

      // Format as HH:mm:ss
      const formattedTime = `${String(hours).padStart(2, '0')}:${String(
        minutes,
      ).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`

      return formattedTime
    },
  },
}
